import React from 'react';
import classNames from 'classnames';
import { PrimaryButton } from '../../components';
import { scrollToPromotixSelectTickets } from './promotixSelectTicketsScroll';
import css from './PromoTixLowPriceGuaranteeBanner.module.css';

const formatMoney = value => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

const PromoTixLowPriceGuaranteeBanner = ({ publicData }) => {
  const widget = publicData?.priceGuaranteeWidget;
  const published = publicData?.priceGuaranteeWidgetPublished === true && widget?.published === true;

  if (!published || widget?.promotixAllIn == null) {
    return null;
  }

  const competitors = Array.isArray(widget.competitors) ? widget.competitors : [];

  return (
    <section
      className={css.root}
      aria-label={widget.title || 'PromoTix Low Price Guarantee'}
      data-testid="price-guarantee-widget"
    >
      <div className={css.inner}>
        <div className={css.copyBlock}>
          <div className={css.copyHeader}>
            <div className={css.badge}>Lowest Price</div>
            <h2 className={css.title}>{widget.title}</h2>
          </div>
          <p className={css.tagline}>{widget.tagline}</p>
        </div>

        <div className={css.priceBoard} aria-label="Verified all-in ticket prices">
          <div className={classNames(css.promotixRow)} role="row">
            <span className={css.sellerName} role="cell">
              <span className={css.promotixMark} aria-hidden="true">
                ✓
              </span>
              {widget.promotixLabel || 'PromoTix'}
              <span className={css.lowestChip}>Lowest</span>
            </span>
            <span className={css.priceValue} role="cell">
              {formatMoney(widget.promotixAllIn)}
            </span>
          </div>

          {competitors.length > 0 ? (
            <div className={css.competitorGrid} role="list" aria-label="Higher competitor prices">
              {competitors.map(entry => (
                <div
                  key={`${entry.displayName}-${entry.allIn}`}
                  className={css.competitorCell}
                  role="listitem"
                >
                  <span className={css.sellerName}>
                    {entry.url ? (
                      <a
                        href={entry.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={css.competitorLink}
                      >
                        {entry.displayName}
                      </a>
                    ) : (
                      entry.displayName
                    )}
                  </span>
                  <span className={css.priceValueMuted}>{formatMoney(entry.allIn)}</span>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>

      <div className={css.ctaRow}>
        <PrimaryButton
          type="button"
          className={css.selectTicketsButton}
          data-testid="price-guarantee-select-tickets"
          onClick={scrollToPromotixSelectTickets}
        >
          Select Tickets
        </PrimaryButton>
      </div>
    </section>
  );
};

export default PromoTixLowPriceGuaranteeBanner;
